import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    tradingBotsAdminControllerListTradingBotsV1: build.query<
      TradingBotsAdminControllerListTradingBotsV1ApiResponse,
      TradingBotsAdminControllerListTradingBotsV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/trading-bots`,
        params: {
          groupName: queryArg.groupName,
          region: queryArg.region,
          type: queryArg['type'],
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type TradingBotsAdminControllerListTradingBotsV1ApiResponse =
  /** status 200 Returns every selectable bot; the entry the creation rules would pick is flagged `recommended` when the query carries the group type */ ListTradingBotsResponse;
export type TradingBotsAdminControllerListTradingBotsV1ApiArg = {
  groupName?: string;
  region?: number;
  type?: 'STANDARD' | 'DEEP_LIQUIDITY' | 'NO_KEYS';
};
export type ListTradingBotsResponse = {
  /** Telegram username of the bot (without the leading @) */
  username: string;
  /** Short human label for the select option */
  label: string;
  /** SPECIAL = named special-purpose bot, EXCHANGE = derived from the exchange the group trades on */
  kind: 'SPECIAL' | 'EXCHANGE';
  /** Exchange this bot belongs to (null for special bots) */
  exchange: null | string;
  /** When to use this bot, spelled out for the admin */
  description: string;
  /** True for the bot the creation rules would pick for the queried group */
  recommended: boolean;
  /** Why this bot is recommended (null when it is not) */
  reasonCode:
    | null
    | (
        | 'DEEP_LIQUIDITY_REGION'
        | 'GROUP_NAME_CEXDEX'
        | 'GROUP_NAME_LOAN'
        | 'GROUP_NAME_MENKAR'
        | 'EXCHANGE_DEFAULT'
      );
  /** Human-readable explanation of the recommendation (null when not recommended) */
  reason: null | string;
}[];
